module.exports = __webpack_public_path__ + "img/logo.87db8307.png";